// import { toast } from "react-toastify";

import { actionTypes } from "redux-form";
// import { Item } from "tripetto-runner-foundation/module/matrix";

const removeKey = (key, { [key]: _, ...rest }) => rest;

const authReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_USER_PROFILE":
      return {
        ...state,
        add_user_profile_status: action.payload,
      };

    case "DELETE_USER_PROFILE":
      return state;

    case "DELETE_USER_PROFILE_LOCAL":
      return {
        ...state,
        fetched_users: state.fetched_users.filter((x) => x.id !== action.payload),
      };

    case "UPDATE_USER_PROFILE":
      return state;

    case "UPDATE_USER_PROFILE_LOCAL": {
      let user_list_ist = [Object.values(state.fetched_users).findIndex((x) => x.id === action.payload.user_id)];
      return {
        ...state,
        fetched_users: {
          ...state.fetched_users,
          [user_list_ist]: {
            ...Object.values(state.fetched_users)[user_list_ist],
            // role: action.payload.user_role,
            role: {
              ...Object.values(state.fetched_users)[user_list_ist].role,
              id: action.payload.user_role.id,
              name: action.payload.user_role.name,
              access: action.payload.user_role.access,
            },
          },
        },
      };
    }

    case "SET_ALL_USERS":
      return {
        ...state,
        add_user_profile_status: action.payload,
      };

    case "FETCH_ALL_USERS":
      return {
        ...state,
        fetched_users: action.payload,
      };

    case "FETCH_USER_INFO":
      return {
        ...state,
        user_info: action.payload,
      };

    case "SET_USER_INFO_LOCAL":
      return {
        ...state,
        user_info: action.payload,
      };

    case "FETCH_PRODUCTS":
      return {
        ...state,
        products: action.payload,
      };

    case "FETCH_SUBSCRIPTION":
      return {
        ...state,
        subscription: action.payload,
      };

    case "SET_USER_ONBOARDING_STEP":
      return state;

    case "GET_SUBSCRIPTION_CHECKOUT_URL":
      return state;

    case "GET_BILLING_MANGEMENT_URL":
      return state;

    case "UPDATE_SUBSCRIPTION_ITEMS":
      return state;

    case "SET_FREE_SUBSCRIPTION_DAYS_LEFT":
      return {
        ...state,
        subscription_days_left: action.payload,
      };

    case "SET_USER_ONBOARDING_STEP_LOCAL":
      return {
        ...state,
        user_info: {
          ...state.user_info,
          usage_info: {
            ...state.user_info.usage_info,
            onboarding_step: action.payload,
          },
        },
      };

    default:
      return state;
  }
};

export default authReducer;
